import careIcons from './svg/care-icons'
import systemIcons from './svg/system-icons'
import largeIcons from './svg/large-icons'

// these are the props for the main Icon components that
// would be used in the app.
export interface IconProps {
  className?: string
  name:
    | keyof typeof careIcons
    | keyof typeof systemIcons
    | keyof typeof largeIcons
  pathClass?: string
  size?: IconSize
  type?: IconType
}

// these are the props for the SVG component that is used
// by Icon (loaded dynamically based on name/type).
export interface IconSVGProps {
  className?: string
  size: number
  pathClass: string
}

export enum IconSize {
  XXS = 'xxs',
  XS = 'xs',
  SM = 'sm',
  MD = 'md',
  LG = 'lg',
  XL = 'xl',
  XXL = 'xxl',
  XXXL = '3xl',
  XXXXL = '4xl',
}

export enum IconType {
  SYSTEM = 'system',
  CARE = 'care',
  LARGE = 'large',
}
